"use client";

import * as React from "react";

import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarRail,
  useSidebar,
} from "@/components/ui/sidebar";
import { NavProjects } from "./nav-projects";
import {
  LogoSvg,
  LogoutSvgIcon,
  NotificationSvgIcon,
  PurchaseOrderSvgIcon,
  RFQSvgIcon,
  SettingsSvgIcon,
  SubmittedBidSvgIcon,
} from "@/assets/svg";
import routesPath from "@/utils/routesPath";

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { isMobile } = useSidebar();
  const { DASHBOARD, SUBMITTED_BIDS, PURCHASE_ORDER, SETTINGS } = routesPath;
  // This is sample data.
  const data = {
    navLinks: [
      {
        name: "RFQs",
        url: DASHBOARD,
        icon: <RFQSvgIcon />,
      },
      {
        name: "Submitted Bids",
        url: SUBMITTED_BIDS,
        icon: <SubmittedBidSvgIcon />,
      },
      {
        name: "Purchase Order",
        url: PURCHASE_ORDER,
        icon: <PurchaseOrderSvgIcon />,
      },
      {
        name: "Notifications",
        url: "/notifications",
        icon: <NotificationSvgIcon />,
      },
      {
        name: "Profile/Settings",
        url: SETTINGS,
        icon: <SettingsSvgIcon />,
        hidden: isMobile ? false : true,
      },
      {
        name: "Logout",
        url: "#",
        icon: <LogoutSvgIcon />,
        hidden: isMobile ? false : true,
      },
    ],
  };
  if (!isMobile) {
    return <></>;
  }

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader className="px-5">
        {/* <TeamSwitcher teams={data.teams} /> */}
        <LogoSvg className="w-28" />
      </SidebarHeader>
      <SidebarContent>
        {/* <NavMain items={data.navMain} /> */}
        <NavProjects projects={data.navLinks} />
      </SidebarContent>
      {/* <SidebarFooter>
        <NavUser user={data.user} />
      </SidebarFooter> */}
      <SidebarRail />
    </Sidebar>
  );
}
